import $ from 'jquery';

export function initDropdown(jsDropdown) {
    $(document).ready(function () {
        $(jsDropdown).click(function (event) {
            event.preventDefault(); 
            $(this).next().toggleClass("panel__show");
        });
    });
}
